import { FormHelperText, Switch } from '@mui/material';
import Typography from '../Typography/index.js';
import useHelperTextId from '@platform-ui-common/hooks/contexts/useHelperTextId.js';
import Color, { BorderColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';

export interface YesNoToggleProps {
  ariaLabel?: string;
  border?: boolean;
  checked: boolean;
  disabled?: boolean;
  error?: string;
  label: string;
  onClick?: (value: boolean) => void;
  readonly?: boolean;
  required?: boolean;
  className?: string;
  withAsterisk?: boolean;
  descriptionId?: string;
}

const YesNoToggle = ({
  ariaLabel,
  border = false,
  checked,
  disabled,
  error,
  label,
  onClick,
  readonly,
  required,
  className,
  withAsterisk,
  descriptionId,
}: YesNoToggleProps) => {
  const onChange = (): void => {
    if (onClick && !readonly) {
      onClick(!checked);
    }
  };
  const helperTextId = useHelperTextId();
  return (
    <>
      <div
        className={cx(
          {
            'flex items-center w-full': true,
            'border border-inputBorder': border,
            [BorderColors[Color.Warning].toString()]: error,
            'bg-lightBackground': checked && border,
          },
          className,
        )}
        key={ariaLabel}
      >
        <Typography variant="label">No</Typography>
        <Switch
          onChange={onChange}
          required={required}
          disabled={disabled}
          checked={checked}
          inputProps={{
            'aria-label': label,
            readOnly: !!readonly,
            'aria-invalid': !!error,
            'aria-errormessage': helperTextId,
            'aria-describedby': descriptionId,
          }}
        />
        <Typography variant="label">Yes{withAsterisk ? '*' : ''}</Typography>
      </div>
      {error && (
        <FormHelperText error={true} id={helperTextId}>
          {error}
        </FormHelperText>
      )}
    </>
  );
};

export default YesNoToggle;
